import React, { Component } from 'react'
import { CardStyle, VideoCardStyle } from './../../styles'

export default class Video extends Component {
  state = {
    active: false,
  }

  componentDidMount() {
    this.scaleVideo()
  }

  handlerClick = (e) => {
    e.preventDefault()

    if (!e.target.classList.contains('video-close') && !e.target.closest('.video-close')) {
      this.setState({ url: this.props.type === 'vimeo' ? `https://player.vimeo.com/video/${this.props.link}?autoplay=1` : `https://www.youtube.com/embed/${this.props.link}?autoplay=1`}, () => {
        this.setState({ active: true })
      })
    }
  }

  handlerClose = (e) => {
    e.preventDefault()
    this.setState({ active: false}, () => {
      this.setState({ url: '' })
    })
  }

  scaleVideo = () => {
    const windowHeight = window.innerHeight
    const videoHeight = this.video
	  const scale = windowHeight / videoHeight
  
    if (videoHeight <= windowHeight) {
      this.video.style.transform = `scale(${scale}) translateY(-50%)`
    }
  }

  render() {
    const { 
      title, 
      poster,
    } = this.props

    return (
      <div className={`card flex ${CardStyle(
         true, 
         poster,
         true
         )} ${VideoCardStyle(this.state.active)}`}>
        <div className='card-inner' onClick={this.handlerClick}>
          <div className='card-picture'></div>
          <div className='card-info'>
            <span className="video-label">{ title }</span>
          </div>
          <div className='card-bottom'>
            <span className='card-link'>Discover</span>
          </div>
          <div className="video-container-full">
            <button className="video-close" onClick={this.handlerClose}>
              <span></span>
              <span></span>
            </button>
            <div className="video-iframe" ref={(video) => this.video = video}>
              <div className="video-wrapper">
                <iframe src={this.state.url} frameBorder="0" allowFullScreen title={ title }></iframe> 
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Videos/Video.js